/**
 * Order confirmation screen copy. Prefix: "ordc."
 *
 * Same accuracy rules as the rest of the dictionary: never translate product
 * or ingredient names, doses, units, prices, pack sizes, certification names
 * or study references, and never strengthen a claim.
 */

export const orderSuccess = {
  en: {
    "ordc.thankYou": "Thank you",
    "ordc.thankYouNamed": "Thank you, {name}",
    "ordc.confirmed": "Your order is confirmed. Your wellness journey begins today.",
    "ordc.stat.order": "Order",
    "ordc.stat.eta": "Estimated delivery",
    "ordc.stat.shippingTo": "Shipping to",
    "ordc.loadingShort": "Loading…",
    "ordc.loading": "Loading your order…",
    "ordc.loadError": "We couldn't load your order details.",

    "ordc.progress.eyebrow": "Progress",
    "ordc.progress.title": "Where your order is",
    "ordc.stage.confirmed": "Confirmed",
    "ordc.stage.packing": "Packing",
    "ordc.stage.shipped": "Shipped",
    "ordc.stage.out": "Out for delivery",
    "ordc.stage.delivered": "Delivered",

    "ordc.box.eyebrow": "In your box",
    "ordc.box.title": "Your protocol",
    "ordc.item.qty": "Qty {qty}",
    "ordc.pill.protocol": "Protocol",
    "ordc.pill.arrives": "Arrives",

    "ordc.ingredients.title": "Questions about your ingredients?",
    "ordc.ingredients.sub": "Ask on WhatsApp for a clear breakdown of what's inside your formula.",
    "ordc.ingredients.cta": "Ask about ingredients",

    "ordc.routine.eyebrow": "Daily ritual",
    "ordc.routine.title": "Your routine, planned",
    "ordc.routine.morning": "Morning",
    "ordc.routine.afternoon": "Afternoon",
    "ordc.routine.night": "Night",
    "ordc.routine.restDay": "rest day",

    "ordc.insight.eyebrow": "Did you know?",

    "ordc.help.eyebrow": "Support",
    "ordc.help.title": "Need a hand?",
    "ordc.help.ingredients": "Ask about ingredients",
    "ordc.help.ingredientsSub": "Get an instant WhatsApp answer",
    "ordc.help.track": "Track order",
    "ordc.help.trackSub": "Live shipment updates",
    "ordc.help.support": "Contact support",
    "ordc.help.supportSub": "We reply within 4 hours",

    "ordc.cta.track": "Track my order",
    "ordc.cta.science": "Explore science",
  },
} as const;
